import type { FunctionComponent } from "react";
import { ImportCsvModalAdminPartial } from "../../../../partials/admin/menus/favourites/import-csv-modal.admin.partials";

export const ImportCsvModalAdminScreen: FunctionComponent = () => {
    return <ImportCsvModalAdminPartial />;
};
